import * as React from 'react';
import { AuthProvider } from '@sportnet/auth-react';
import { CustomThunkDispatch } from './configureStore';
import { connect } from 'react-redux';
import Invitation from './pages/Invitation';
import SportnetApi from './sportnetApi';
import api from './api';
import config from './config';

interface OwnProps {
  dispatch: CustomThunkDispatch;
}

type Props = OwnProps;

const Routes: React.FC<Props> = (props) => {
  const [loading, setLoading] = React.useState(true);

  return (
    <AuthProvider
      app={config.APP_ID}
      onAuthorize={({ accessToken }) => {
        if (accessToken) {
          api.setToken(accessToken || '');
          SportnetApi.setToken(accessToken || '');
          setLoading(false);
        }
      }}
    >
      {loading ? null : <Invitation {...props} />}
    </AuthProvider>
  );
};

export default connect()(Routes);
